export const GET_ALL_NOTES = 'GET_ALL_NOTES'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
